import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "information",
  class: "info-container"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_3 = { class: "info-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "info-image-wrapper" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]

import { ref, onMounted } from 'vue';

  interface InfoCard {
    id: string;
    title: string;
    text: string;
    bgColor: string;
    textColor: string;
    reverse: boolean;
    imageUrl: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSection',
  setup(__props) {

  const HYGRAPH_ENDPOINT = process.env.VUE_APP_HYGRAPH_URL;

  const selectedCard = ref<InfoCard | null>(null);
  const infoCards = ref<InfoCard[]>([]);
  const loading = ref(true);

  const fetchInfoCards = async () => {
    const query = `
      query GetInfoCards {
        informations {
          id
          title
          text
          bgColor { hex }
          textColor { hex }
          reverse
          visible
          images { url }
        }
      }
    `;

    try {
      const response = await fetch(HYGRAPH_ENDPOINT!, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      });
      
      const { data } = await response.json();

      

      if (data && data.informations) 
      {
        infoCards.value = data.informations.filter(item => item.visible).map((item: any) => ({
          id: item.id,
          title: item.title,
          text: item.text,
          reverse: item.reverse,
          bgColor: item.bgColor?.hex || '#F5F5F0', 
          textColor: item.textColor?.hex || '#333',
          imageUrl: item.images?.[0]?.url || item.images?.url || ''
        }));
      }
    } catch (error) {
      console.error("Erro ao carregar InfoCards:", error);
    } finally {
      loading.value = false;
    }
  };

  const openModal = (card: InfoCard) => {
    selectedCard.value = card;
    document.body.style.overflow = 'hidden'; // Trava o scroll do fundo
  };

  const closeModal = () => {
    selectedCard.value = null;
    document.body.style.overflow = 'auto'; // Destrava o scroll
  };

  onMounted(fetchInfoCards);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando informações..."))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(infoCards.value, (card) => {
          return (_openBlock(), _createElementBlock("div", {
            key: card.id,
            class: _normalizeClass(["info-card", { 'row-reverse': card.reverse }]),
            style: _normalizeStyle({ backgroundColor: card.bgColor, color: card.textColor })
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", {
                class: "info-title",
                innerHTML: card.title
              }, null, 8, _hoisted_4),
              _createElementVNode("div", {
                class: "info-text ql-editor line-clamp",
                innerHTML: card.text
              }, null, 8, _hoisted_5),
              _createElementVNode("button", {
                onClick: ($event: any) => (openModal(card)),
                class: "read-more-btn text-cyan-400 hover:text-cyan-600"
              }, " Continue lendo... ", 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: card.imageUrl,
                alt: card.title,
                class: "info-img"
              }, null, 8, _hoisted_8)
            ])
          ], 6))
        }), 128)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (selectedCard.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-overlay",
              onClick: _withModifiers(closeModal, ["self"])
            }, [
              _createElementVNode("div", {
                class: "modal-content",
                style: _normalizeStyle({ backgroundColor: selectedCard.value.bgColor, color: selectedCard.value.textColor })
              }, [
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: closeModal
                }, "✕"),
                (selectedCard.value.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: selectedCard.value.imageUrl,
                      class: "modal-header-img"
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "modal-title",
                    innerHTML: selectedCard.value.title
                  }, null, 8, _hoisted_11),
                  _createElementVNode("div", {
                    class: "ql-editor",
                    innerHTML: selectedCard.value.text
                  }, null, 8, _hoisted_12)
                ])
              ], 4)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})